import React from 'react'
import Music from '../../components/music'

export default (props) => (
  <Music
    {...props}
    currentLanguage='fr'
  />
)
